<template>
    <div>
        <div class="breadcrumb-section jarallax pixels-bg" data-jarallax data-speed="0.6">
            <div class="container text-center">
                <h1>A PROPOS DE NOUS</h1>
                <ul>
                    <li><a href="/">Accueil</a></li>
                    <li><a href="javascript:void(0);">A propos de nous</a></li>
                </ul>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-12">
                        <img src="/static/img/content/about/about-us-1.jpg" class="rounded-border shadow-primary" alt="">
                    </div>
                    <div class="col-md-6 col-sm-6 col-12">
                        <div class="pl-30-md">
                            <div class="section-heading text-left mt-5">
                                <h3 class="semi-bold font-size-30">
                                    INTERNATIONAL BUSINESS DEVELOPMENT AND <span class="primary-color">INTERMEDIATION</span>
                                </h3>
                                <!-- <h3 class="semi-bold font-size-32">All-in-One Professional Solution for <span
                                        class="primary-color">Your Business</span></h3> -->
                                <div class="section-heading-line line-thin"></div>
                                <div class="text-content">
                                    <p>
                                        Experte en développement d'entreprise et en intermédiation, 
                                        IBDI est une société à responsabilité limitée (SARL) qui regroupe en son sein 
                                        des experts en Ingénierie financière, en Immobilier, en Accompagnement d'entreprise, 
                                        en Administration et bureautique multi-service et en Hydraulique et Forages.
                                    </p>
                                </div>
                            </div>
                            <div class="primary-list mt-25">
                                <ul>
                                    <li><i class="fas fa-check-circle"></i>Professionalisme</li>
                                    <li><i class="fas fa-check-circle"></i>Accompagnement</li>
                                    <li><i class="fas fa-check-circle"></i>Proximité</li>
                                    <li><i class="fas fa-check-circle"></i>Satisfaction</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-block-parallax jarallax primary-overlay-80" data-jarallax data-speed="0.6" style="background-image: url('https://ninetheme.com/themes/lumire/wp-content/uploads/2019/03/bg4.jpg');">
            <div class="container">
                <div class="large-heading text-center">
                    <small class="semi-bold white-color">
                        Nos experts sont disponibles pour méner à bien vos projets
                    </small>
                    <h4 class="semi-bold white-color">
                        Profitez dès à présent de notre expérience et de notre professionnalisme.
                    </h4>
                </div>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-12">
                        <div class="pr-45-md">
                            <div class="section-heading text-left">
                                <h3 class="semi-bold font-size-30">Mot du dirigeant</h3>
                                <div class="section-heading-line line-thin"></div>
                            </div>
                            <div class="text-content-big mt-25">
                                <p>
                                    Notre entreprise International Business Development And Intermediation 
                                    en abrégé IBDI a toujours eu pour but d'être proche de sa clientèle et 
                                    de ses partenaires afin de répondre efficacement à leurs besoins et attentes. 
                                    Ainsi nous avons mis en place cette plateforme avec pour objectif principal de 
                                    renforcer la communication avec vous nos clients et partenaires techniques et financiers.
                                </p>
                            </div>
                            <a href="#" class="button-simple mt-15" data-toggle="modal" data-target="#exampleModal">Lire la suite <i class="fa fa-arrow-right primary-color"></i></a>
                            <!-- Modal -->
                            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <p>
                                            Notre entreprise International Business Development And Intermediation en abrégé 
                                            IBDI a toujours eu pour but d'être proche de sa clientèle et de ses partenaires 
                                            afin de répondre efficacement à leurs besoins et attentes.
                                            <br />
                                            Ainsi nous avons mis en place cette plateforme avec pour objectif principal de 
                                            renforcer la communication avec vous nos clients et partenaires techniques et financiers. 
                                            Nous voulons que cet espace de communication soit proche de vous et que vous vous y sentiez confortable.
                                            <br />
                                            <br />
                                            Parce que nous attachons du prix à votre satisfaction, vous trouverez sur cette plateforme des informations sur nos projets, 
                                            nos  réalisations ainsi que les services proposés.Nous nous efforcerons, autant que faire se peut, d’œuvrer à mettre à la 
                                            disposition de nos différents partenaires cibles les informations et outils nécessaires à la satisfaction de leurs besoins.
                                            C’est en cela que la rubrique « contact » pourrait être un excellent support de communication entre vous et nous.. 
                                            <br />
                                            Vos opinions diverses, qui se traduiront par des remontées constantes d’informations « feed-back » seront pour nous 
                                            une source de motivation supplémentaire vers la réalisation de notre grande ambition qui est de vous servir avec rigueur, 
                                            professionnalisme et dont le respect des engagements est notre crédo pour lequel vous ne cessez de nous faire confiance ; 
                                            croyez nous, nous vous accompagnerons après l’horizon.
                                            <br />
                                            <br />
                                            Bienvenue sur notre site.
                                        </p>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">FERMER</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-12">
                        <img src="/static/img/content/about/about-us-2.jpg" alt="" class="rounded-border shadow-primary">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'AboutUs',
  data () {
    return {
      services: null,
      url: BASE_URL
    }
  },
  mounted () {
    this.getServices()
  },
  methods: {
    getServices () {
      let url = BASE_URL + API_PREFIX + API_VERSION + '/services'
      this.$http.get(url)
        .then((response) => {
          this.services = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue